"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showPopup = void 0;
// Show popup logic
function showPopup(popupSelector, currentTime, occurrenceTime, closeAfterMs, player, playerPlay, onClose) {
    if (currentTime !== occurrenceTime) {
        return;
    }
    let timer = null;
    const popup = document.querySelector(popupSelector);
    const popupContainer = document.querySelector(".archived-video__popup-container");
    const closeButton = document.getElementById("popup-close");
    if (popup) {
        popup.style.display = "block";
        clearTimeout(timer !== null && timer !== void 0 ? timer : "");
        timer = setTimeout(() => {
            popupContainer === null || popupContainer === void 0 ? void 0 : popupContainer.classList.add("show");
        }, 300);
        if (player) {
            player.pause();
        }
        if (document.fullscreenElement && document.exitFullscreen) {
            document.exitFullscreen();
        }
        const closePopup = (event) => {
            if (event.target === popup) {
                popup.style.display = "none";
                playerPlay.play();
            }
        };
        if (closeButton) {
            closeButton.classList.remove("button-show");
            setTimeout(() => {
                closeButton.classList.add("button-show");
                popup.addEventListener("click", closePopup);
                closeButton.onclick = () => {
                    popup.style.display = "none";
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                    playerPlay.play();
                };
            }, closeAfterMs);
        }
    }
    else {
        console.error("Popup element not found!");
    }
}
exports.showPopup = showPopup;
